'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldHideWelcomeMessage = exports.getIsOpen = exports.getIsMobile = undefined;

var _reselect = require('reselect');

var getWidgetUiState = function getWidgetUiState(state) {
  return state.widgetUi;
};

var getIsMobile = exports.getIsMobile = (0, _reselect.createSelector)([getWidgetUiState], function (widgetUi) {
  return widgetUi.mobile;
});

var getIsOpen = exports.getIsOpen = (0, _reselect.createSelector)([getWidgetUiState], function (widgetUi) {
  return widgetUi.open;
});

var getShouldHideWelcomeMessage = exports.getShouldHideWelcomeMessage = (0, _reselect.createSelector)([getWidgetUiState], function (widgetUi) {
  return widgetUi.hideWelcomeMessage;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetUiSelectors.js
// module id = 213
// module chunks = 0 1